import { Fragment, Suspense } from "react";
import React from "react";
import Introduction from "./_sections/introduction/Introduction";
import VideoMontage from "./_sections/video_montage/VideoMontage";
import Numbers from "./_sections/numbers/Numbers";
import Technologies from "./_sections/technologies/Technologies";
import HdmiBoard from "./_sections/hdmi_board/HdmiBoard";
import HandVolume from "./_sections/hand_volume/HandVolume";
import Gaming from "./_sections/gaming/Gaming";
import RelatedProducts from "./_sections/related_products/RelatedProducts";
import SmartEngineering from "./_sections/smart_engineering/SmartEngineering";
import ClosingStatement from "./_sections/closing/ClosingStatement";
import SoundWave from "./_sections/soundwave/SoundWave";
import Newsletter from "./_sections/newsletter/Newsletter";
import Locator from "./_sections/locator/Locator";
import AudioFormats from "./_sections/audio_formats/AudioFormats";
import ComplexSimplicity from "./_sections/complex_simplicity/ComplexSimplicity";
import StreamingOptions from "./_sections/streaming_options/StreamingOptions";
import Integration from "./_sections/integration/Integration";
import LimitlessPossibilies from "./_sections/limitless_possibilies/LimitlessPossibilies";
import Gallery from "./_sections/gallery/Gallery";
import RotatingVideo from "./_sections/rotating_video/RotatingVideo";
import HalfTurn from "./_sections/half_turn_video/HalfTurn";

// import Hero from "./_sections/hero/Hero";
import Banner from "./_sections/banner/Banner";

const Hero = React.lazy(() => import("./_sections/hero/Hero"));

export const blocks = [
  {
    lazy: true,
    title: "Hero",
    component: <Hero />,
    ref: false,
  },
  {
    lazy: true,
    title: "Introduction",
    component: <Introduction />,
    ref: false,
  },
  {
    lazy: true,
    title: "Video Montage",
    component: <VideoMontage />,
    ref: false,
  },
  {
    lazy: true,
    title: "Gallery",
    component: <Gallery />,
    ref: true,
    url: "gallery",
  },
  {
    lazy: true,
    title: "Numbers",
    component: <Numbers />,
    ref: false,
  },
  {
    lazy: false,
    title: "Hdmi Board",
    component: <HdmiBoard />,
    ref: false,
  },
  // {
  //   title: "Rotating Video",
  //   component: <RotatingVideo />,
  //   ref: false,
  // },
  {
    lazy: true,
    title: "Gaming",
    component: <Gaming />,
    ref: false,
  },
  {
    lazy: false,
    title: "Audio Formats",
    component: <AudioFormats />,
    ref: false,
  },
  // {
  //   title: "Half Turn",
  //   component: <HalfTurn />,
  //   ref: false,
  // },

  {
    lazy: true,
    title: "SoundWave",
    component: <SoundWave />,
    ref: false,
  },
  {
    lazy: false,
    title: "Smart Engineering",
    component: <SmartEngineering />,
    ref: false,
  },

  {
    lazy: false,
    title: "Totality or Nothing",
    component: <HandVolume />,
    ref: false,
  },
  {
    lazy: false,
    title: "Streaming Options",
    component: <StreamingOptions />,
    ref: false,
  },
  {
    lazy: false,
    title: "Complex Simplicity",
    component: <ComplexSimplicity />,
    ref: false,
  },

  {
    lazy: false,
    title: "Limitless Possibilies",
    component: <LimitlessPossibilies />,
    ref: false,
  },
  {
    lazy: false,
    title: "Integration",
    component: <Integration />,
    ref: false,
  },
  {
    lazy: false,
    title: "Technologies",
    component: <Technologies />,
    ref: true,
    url: "technologies",
  },
  {
    lazy: true,
    title: "Closing Statement",
    component: <ClosingStatement />,
    ref: false,
  },
  {
    lazy: false,
    title: "Related Products",
    component: <RelatedProducts />,
    ref: true,
    url: "related_products",
  },
  {
    lazy: false,
    title: "Dealer Locator",
    component: <Locator />,
    ref: true,
    url: "dealer_locator",
  },
  {
    lazy: false,
    title: "Banner",
    component: <Banner />,
    ref: false,
  },
];

export function Dispatch() {
  return blocks.map((block, index) => (
    <Suspense fallback={""}>
      <Fragment key={index}> {block.component}</Fragment>
    </Suspense>
  ));
}
